var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.6202 8.7C19.5802 4.07 15.5402 2 12.0002 2C12.0002 2 12.0002 2 11.9902 2C8.46024 2 4.43024 4.07 3.38024 8.69C2.20024 13.85 5.36024 18.22 8.22024 20.98C9.28024 22 10.6402 22.51 12.0002 22.51C13.3602 22.51 14.7202 22 15.7702 20.98C18.6302 18.22 21.7902 13.86 20.6202 8.7Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7499 13.7499C10.5599 13.7499 10.3699 13.6799 10.2199 13.5299L8.71994 12.0299C8.42994 11.7399 8.42994 11.2599 8.71994 10.9699C9.00994 10.6799 9.48994 10.6799 9.77994 10.9699L10.7499 11.9399L14.2199 8.46994C14.5099 8.17994 14.9899 8.17994 15.2799 8.46994C15.5699 8.75994 15.5699 9.23994 15.2799 9.52994L11.2799 13.5299C11.1299 13.6799 10.9399 13.7499 10.7499 13.7499Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationTick);
export default __webpack_public_path__ + "static/media/location-tick.8deefc682ecdda8d8d57cab872a21f09.svg";
export { ForwardRef as ReactComponent };